import { useEffect, useState } from "react"

// import { useScenarioType } from "./ScenarioTypeContext"

import AddButton from "./AddButton"
import InputWithErrorMessage from "./InputWithErrorMessage"

const AddEntity = ({ entitiesDesc, addHandler, uniqueIDs=[], uniqueLabels=[] }) => {
    // const {uniqueIDs, uniqueLabels} = useScenarioType()
    const [labelsUnique, setLabelsUnique] = useState(false)
    const [entityType, setEntityType] = useState(null)
    const [entityName, setEntityName] = useState(null)
    const [newID, setNewID] = useState("")
    const [newIDErrMsg, setNewIDErrMsg] = useState("")
    const [newLabel, setNewLabel] = useState("")
    const [newLabelErrMsg, setNewLabelErrMsg] = useState("")

    const changeID = (event) => {
        const {value} = event.target
        setNewID(value)
        setNewIDErrMsg(!uniqueIDs.includes(value) ? "" : "Not Unique")
    }

    const changeLabel = (event) => {
        const {value} = event.target
        setNewLabel(value)
        if (labelsUnique) {
            setNewLabelErrMsg(!uniqueLabels.includes(value) ? "" : "Not Unique")
        }
    }

    const onAdd = (event) => {
        if (newIDErrMsg !== "" || newLabelErrMsg !== "") {
            alert("Please correct errors before submitting")
        } else {
            addHandler(entityType, newID, newLabel)
            setNewID("")
            setNewIDErrMsg("")
            setNewLabel("")
            setNewLabelErrMsg("")
        }
    }

    useEffect(
        () => {
            if (!entityType) {
                setEntityType(entitiesDesc[0].type)
                setEntityName(entitiesDesc[0].name)
                setLabelsUnique(entitiesDesc[0].labelsUnique)
            }
        }, [entitiesDesc, entityType]
    )

    return (
        <div className="add-entity">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>ID</th>
                        <th>Label</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <b>Add {entityName}</b>
                        </td>
                        <td>
                            <InputWithErrorMessage
                                value={newID}
                                errMsg={newIDErrMsg}
                                onChange={changeID}
                            />
                        </td>
                        <td>
                            <InputWithErrorMessage
                                value={newLabel}
                                errMsg={newLabelErrMsg}
                                onChange={changeLabel}
                            />
                        </td>
                        <td>
                            <AddButton addHandler={onAdd} />
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    )
}

export default AddEntity